export default "__VITE_ASSET__fn$Zta7d__"